import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6322cf74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "text-m-regular" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.contact.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.contact.email)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "icon",
            href: `mailto:${_ctx.contact.email}`,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackContact('email', _ctx.contactType)))
          }, [
            _createVNode(_component_use_svg, { svg: "mail" })
          ], 8, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.contact.phone)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "icon",
            href: `tel:${_ctx.contact.phone}`,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackContact('phone', _ctx.contactType)))
          }, [
            _createVNode(_component_use_svg, { svg: "phone" })
          ], 8, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}